import uiuxIcon from "../assets/icons/uiux-icon.svg";
import frontendIcon from "../assets/icons/front-icon.svg";
import flutterIcon from "../assets/icons/course-flutter.svg";
import laravelIcon from "../assets/icons/backend-laravel.svg";
import aspIcon from "../assets/icons/backend-aspsvg.svg";

// صور المدربين (غيّرها لمساراتك)
import uiuxTeacher from "../assets/images/uiux-teacher.png";
import frontendTeacher from "../assets/images/front-teacher.png";
import flutterTeacher from "../assets/images/flutter-teacher.png";
import laravelTeacher from "../assets/images/laravel-teacher.png";
import aspTeacher from "../assets/images/asp-teacher.png";

import instagramIcon from "../assets/icons/instagram-icon.svg";
import facebookIcon from "../assets/icons/facebook-icon.svg";

import uiuxPdf from "../assets/files/UI-UX-DESIGN.pdf";
import frontendPdf from "../assets/files/Front-END.pdf";
import flutterPdf from "../assets/files/Flutter.pdf";
import laravelPdf from "../assets/files/laravel.pdf";
import aspPdf from "../assets/files/ASP.NET.pdf";
export const courses = [
  {
    slug: "ui-ux",

    title: "UI UX Design",

    icon: uiuxIcon,
    description1:"تصميم واجهات مستخدم تجمع بين الجمالية، الوظيفية، وتجربة المستخدم السلسة .",

    description:
      "كورس UI/UX يفتح للطالب باب تصميم التجارب الرقمية باحتراف، من فهم المستخدم وبناء الفكرة، إلى تصميم واجهات حديثة وجذابة قابلة للتنفيذ. الهدف أن يتعلم الطالب كيف يصنع تطبيقاً أو موقعاً او منصة لا تبدو جميلة فقط، بل يكون سهل الاستخدام، واضحاً .",

    trainingType: "أونلاين",

    levels: "2",

    duration: "5 أشهر",

    hours: "110 ساعة",

    price: "140$",

    sessions: "+55",

    projects: "8+",

    certificate: "شهادة إتمام",

    portfolio: "بناء معرض أعمال (Protfolio)",

    jobReady: "التجهيز والتأهيل لسوق العمل ",

    pdf: uiuxPdf,

    instructor: {
      image: uiuxTeacher,
      name: "محمد الشيخ",
      job: "مصمم UI UX Design",
      description:
       "أنا محمد الشيخ، مصمم UI/UX بخبرة تزيد عن 4 سنوات في تصميم واجهات وتجارب المستخدم للتطبيقات والمواقع. عملت على أكثر من 50 مشروعاً في سوريا وتركيا والخليج وأوروبا، مما منحني خبرة عملية في تحويل الأفكار إلى منتجات رقمية واضحة، جذابة، وقابلة للتنفيذ. حاصل على شهادة UI/UX من منظمة MAPS، وشهادة التفكير التصميمي من Field."
         ,social: [
   
    {
      icon: instagramIcon,
      link: "https://www.instagram.com/m_a_sheikhh?igsh=dWl1c2ptY3B6eHQy"
    }
  ]
    },

    before: [
      "لا تمتلك أي أعمال",
      "لا تعرف من أين تبدأ",
      "لا تعرف ما هو UI/UX",
      "لا تتقن Figma",
      "لا تعرف استغلال أدوات الذكاء الاصطناعي"
    ],

    after: [
      "تمتلك Portfolio احترافي",
      "جاهز لسوق العمل",
      "تفهم أساسيات UI/UX باحتراف",
      "تتقن استخدام Figma",
      "تستخدم أدوات AI باحتراف في عملك"
    ]
  },

  {
    slug: "frontend",

    title: "Front-End Development",

    icon: frontendIcon,
    description1:"بناء واجهات ويب تفاعلية وسريعة باستخدام أحدث تقنيات الـ Frameworks.",
    description:
"أتقن تطوير واجهات المواقع الحديثة من الصفر باستخدام أحدث التقنيات، وتعلّم كيف تحوّل أي تصميم إلى موقع سريع، متجاوب، وسهل الاستخدام باحترافية. خلال الكورس ستنفذ مشاريع عملية تحاكي احتياجات سوق العمل، وتبني معرض أعمال قوي يمنحك الثقة للانطلاق في مسيرتك المهنية.",
    trainingType: "أونلاين",

        levels: "2",

    duration: "5 أشهر",

    hours: "110 ساعة",

    price: "140$",

    sessions: "+55",

    projects: "8+",

    certificate: "شهادة إتمام",

    portfolio: "بناء معرض أعمال (Protfolio)",

    jobReady: "التجهيز والتأهيل لسوق العمل ",

    pdf: frontendPdf,

    instructor: {
      image: frontendTeacher,
      name: "غيث أبو بكر",
      job: "مصمم Front-end Delevpment",
      description:
"أنا غيث أبو بكر، مطوّر Front-End شغوف بتطوير واجهات المستخدم الحديثة والتفاعلية، ولدي خبرة في تنفيذ العديد من المشاريع باستخدام أحدث تقنيات تطوير الويب. أحرص على كتابة كود منظم وتقديم تجربة مستخدم مميزة تجمع بين الأداء والتصميم الجذاب. أحمل شهادة Front-End Development من شركة تكنوفا، بالإضافة إلى شهادة من جمعية نماء، وأسعى دائمًا لتطوير مهاراتي ومواكبة أحدث التقنيات في مجال تطوير الويب."    ,
        social: [
    
    {
      icon: instagramIcon,
      link: "https://www.instagram.com/g.10.m.10"
    }
  ],

    },

    before: [
      "لا تملك أي أعمال",
      "لا تعرف من أين تبدأ",
      "لا تعرف ما هو Front-End",
      "لا تعرف استخدام ادوات تطوير المواقع",
      "لا تعرف استغلال أدوات الذكاء الاصطناعي"
    ],

    after: [
      "تمتلك Portfolio احترافي",
      "جاهز لسوق العمل",
      "تتقن تطوير واجهات الويب الحديثة",
      "تتقن استخدام ادوات تطوير المواقع",
      "تستخدم أدوات AI باحتراف في عملك"
    ]
  },

  {
    slug: "flutter",

    title: "Flutter Mobile App",

    icon: flutterIcon,
    description1:"تطوير تطبيقات هواتف ذكية (iOS & Android) فائقة الأداء بكود برمجي موحد.",

    description:
"طوّر تطبيقات Android وiOS من قاعدة كود واحدة باستخدام Flutter، وتعلّم تصميم واجهات عصرية، إدارة البيانات، وربط التطبيقات مع APIs بطريقة احترافية. ستنفذ مشاريع عملية قابلة للنشر، وتبني تطبيقات حقيقية تضيفها إلى معرض أعمالك وتزيد فرصك في الحصول على عمل أو مشاريع Freelance.",
    trainingType: "أونلاين",

        levels: "2",

    duration: "5 أشهر",

    hours: "110 ساعة",

    price: "140$",

    sessions: "+55",

    projects: "8+",

    certificate: "شهادة إتمام",

    portfolio: "بناء معرض أعمال (Protfolio)",

    jobReady: "التجهيز والتأهيل لسوق العمل ",
    pdf: flutterPdf,

    instructor: {
      image: flutterTeacher,
      name: "بلال قنبر",
      job: " Flutter Mobile App",
      description:
        "بلال قنبر، مطوّر تطبيقات جوال متخصص في Flutter، بخبرة تزيد على ثلاث سنوات في تصميم وتطوير التطبيقات الحديثة، وتنفيذ مشاريع حقيقية ضمن بيئات عمل احترافية.  خبرة في إدارة المشاريع البرمجية وتحسين تجربة المستخدم. حاصل على شهادة مطوّر تطبيقات جوال من منظمة MAPS، وأسعى إلى نقل الخبرة العملية والمعرفة التقنية للمتدربين بأسلوب مبسط وفعّال.",
        social: [
    
    {
      icon: instagramIcon,
      link: "https://www.instagram.com/ka_bila0l?igsh=Y2FyYjdlejdnb2Zl"
    }
  ],

    },

    before: [
      "لا تملك أي أعمال",
      "لا تعرف من أين تبدأ",
      "لا تعرف أساسيات تطوير تطبيقات الموبايل.",
      "لا تملك Portfolio",
      "لا تعرف استغلال أدوات الذكاء الاصطناعي"
    ],

    after: [
      "تمتلك Portfolio احترافي",
      "جاهز لسوق العمل",
      "تتقن تطوير تطبيقات Android وiOS.",
      "تستخدم Flutter وDart باحتراف.",
      "تستخدم أدوات AI باحتراف في عملك"
    ]
  },

  {
    slug: "laravel",

    title: "Back-end Laravel",

    icon: laravelIcon,
    description1:"إطار عمل PHP مفتوح المصدر لتطوير تطبيقات الويب بسرعة وسهولة وفق نمط MVC .",

    description:
"تعلّم بناء الأنظمة الاحترافية باستخدام Laravel، بدءًا من إدارة قواعد البيانات وإنشاء REST APIs وصولًا إلى أنظمة المصادقة، الصلاحيات، والحماية. ستعمل على مشاريع متكاملة تحاكي بيئة العمل الحقيقية، وتكتسب المهارات التي تحتاجها للعمل كمطور Back-End محترف.",
    trainingType: "أونلاين",

        levels: "2",

    duration: "5 أشهر",

    hours: "110 ساعة",

    price: "150$",

    sessions: " +60  ",

    projects: " 8+  ",

    certificate: "شهادة إتمام",

    portfolio: "بناء معرض أعمال (Protfolio)",

    jobReady: "التجهيز والتأهيل لسوق العمل ",
    pdf:laravelPdf,

    instructor: {
      image: laravelTeacher,
      name: "عبد الرحمن هلال",
      job: "  Back-end Laravel",
      description:
        ` عبدالرحمن هلال Laravel Backend Developer.
ساهمت في تطوير مشاريع الشحن الدولي، وإدارة المستودعات والمندوبين، وتحليل بيانات فروع مصنع دوائي، ونظام الكهرباء في الشمال السوري.
متخصص في تصميم قواعد البيانات، وتطوير واجهات REST API، وبناء الأنظمة الخلفية من الصفر ضمن فرق برمجية وبمسؤولية مستقلة.`
        ,social: [
    
    {
      icon: instagramIcon,
      link: "https://www.instagram.com/abdr_hilal?igsh=cTNrbnk0eTNtendl"
    }
  ],
    },

    before: [
      "لا تملك أي أعمال",
      "لا تعرف من أين تبدأ",
      "لا تعرف أساسيات Back-End laravel",
      "لا تعرف لغة PHP أو إطار Laravel.",
      "لا تعرف استغلال أدوات الذكاء الاصطناعي"
    ],

    after: [
      "تمتلك Portfolio احترافي",
      "جاهز لسوق العمل",
      "تتقن تطوير الأنظمة باستخدام Laravel",
      "تستخدم PHP وLaravel باحتراف.",
      "تستخدم أدوات AI باحتراف في عملك"
    ]
  },

  {
    slug: "asp-net",

    title: "  Back-end ASP.NET Core",

    icon: aspIcon,
    description1:"إطار عمل من مايكروسوفت لتطوير تطبيقات ومواقع ويب ديناميكية وآمنة باستخدام لغة C#.",

    description:
      "ابدأ رحلتك في تطوير الأنظمة القوية باستخدام ASP.NET Core، وتعلّم إنشاء تطبيقات وواجهات برمجية احترافية وفق أفضل الممارسات المعتمدة في الشركات. من خلال مشاريع عملية متكاملة، ستبني خبرة حقيقية وتمتلك Portfolio يعكس مهاراتك ويؤهلك لسوق العمل.",

    trainingType: "أونلاين",

        levels: "2",

    duration: "5 أشهر",

    hours: "110 ساعة",

    price: "150$",

    sessions: "+60",

    projects: "8+",

    certificate: "شهادة إتمام",

    portfolio: "بناء معرض أعمال (Protfolio)",

    jobReady: "التجهيز والتأهيل لسوق العمل ",

    pdf: aspPdf,

    instructor: {
      image: aspTeacher,
      name: "نايف النايف",
      job: "  Back-end ASP.NET Core",
      description:
        "انا نايف حميدي ,مهندس معلوماتية اختصاص Full Stack (ASP.Net core and Angular) بخبرة تزيد عن سنتين عملت على مشاريع حرة عديدة منها ضمن مواقع عمل حر واخرى امتلك تجارب عملية كثيرة اضافة الى حصولي على شهادة خبرة من قبل منظمة مداد ضمن مبادرة 1000 program كمختص full stack .",
        social: [
    
    {
      icon: instagramIcon,
      link: "https://www.instagram.com/naief.911?igsh=OTh1cDBsMDRhaWxp"
    }
  ],
    },

    before: [
      "لا تملك أي أعمال",
      "لا تعرف من أين تبدأ",
      "لا تعرف أساسيات Back-End.NET.",
      "لا تعرف لغة C# أو ASP.NET Core",
      "لا تعرف استغلال أدوات الذكاء الاصطناعي"
    ],

    after: [
      "تمتلك Portfolio احترافي",
      "جاهز لسوق العمل",
      "تتقن تطوير الأنظمة باستخدام NET Core.",
      "تستخدم C# وASP.NET باحتراف",
      "تستخدم أدوات AI باحتراف في عملك"
    ]
  }
];